module.exports = __webpack_public_path__ + "font2.f8c40cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font2.png
// module id = kdoO
// module chunks = 0